export enum CategoriesEnum {
    ESSENTIAL = "ESSENTIAL",
    FUNCTIONAL = "FUNCTIONAL",
    ANALYTICS = "ANALYTICS",
    MARKETING = "MARKETING",
    OTHER = "OTHER"
}